import { useAtom } from 'jotai'
import { MySwitch } from '~/components/ui/MySwitch'
import { hasAdvanceAtom } from './atom'

export const AdvanceComp = () => {
  const [hasAdvance, setHasAdvance] = useAtom(hasAdvanceAtom)

  return (
    <div className="flex items-center justify-between mb-8">
      <span className="mr-3 text-neutral-800 text-base">高级设置</span>
      <MySwitch
        checked={hasAdvance}
        onChange={checked => {
          setHasAdvance(checked)
        }}
      />
    </div>
  )
}
